var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern__Icn/40px/Stern",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stern__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stern__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,9 L23.2328189,15.5504065 L30.4616217,16.6008131 L25.2308108,21.6995935 L26.4656378,28.8991869 L20,25.5 L13.5343622,28.8991869 L14.7691892,21.6995935 L9.53837832,16.6008131 L16.7671811,15.5504065 L20,9 Z M21.9046879,17.3784221 L20,13.519 L18.0953121,17.3784221 L13.836,17.997 L16.9181503,21.0013537 L16.19,25.242 L20,23.2404485 L23.809,25.242 L23.0818497,21.0013537 L26.163,17.997 L21.9046879,17.3784221 Z",
    id: ".._.._src_svg_Icn_40px_Stern__Star-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStern);
export default __webpack_public_path__ + "static/media/Stern.0e30c0aacd375deea6b0574a8b7dcf35.svg";
export { ForwardRef as ReactComponent };